import type { Product } from '@/db/models/Inventory';
import type { ProductForBilling } from './billingEngine';

/**
 * Map a WatermelonDB Product row to the shape the billing engine / cart store
 * expects. Shared by the billing catalog and the dashboard quick-sale bar so
 * "add to cart" behaves identically wherever a product is picked or scanned.
 */
export function toBillingProduct(p: Product): ProductForBilling {
  return {
    id: p.id,
    name: p.name,
    sellingPrice: p.sellingPrice,
    mrp: p.mrp,
    gstRate: p.gstRate,
    cessRate: p.cessRate,
    hsnCode: p.hsnCode,
    unit: p.unit,
    currentStock: p.currentStock,
    isService: p.isService,
    trackInventory: p.trackInventory,
    imageUrl: p.imageUrl,
    categoryId: p.categoryId,
    barcode: p.barcode,
    sku: p.sku,
    purchasePrice: p.purchasePrice,
  };
}
